import {GraphLevel} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {AnalysisPrivacyStatus, AnalysisStatus, HttpError} from '@hconnect/common/types'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../localization'

export type ResponseType = {
  analysisId: number
  levels: GraphLevel[]
  selectedNodeId: number
}

export const QueryKey = 'graph-data'

type AnalysisUpdateData = {
  Id?: number
  title?: string
  contributorsToAdd?: Array<string | undefined>
  contributorsToRemove?: Array<string | undefined>
  externalGroupId?: string
  privacyStatus?: string | AnalysisPrivacyStatus
  status?: string | AnalysisStatus
  Owner?: string
  DeleteStoppageStart?: boolean
  DeleteStoppageEnd?: boolean
  deleteStoppageCode?: boolean
  stoppageCode?: string
  stoppageStart?: string
  stoppageCodeType?: string
  stoppageEnd?: string
  stoppageId?: string
  dueDate?: string
  deleteDueDate?: boolean
}

export const usePatchAnalysis = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: async (analysisData: AnalysisUpdateData) => {
      const path = '/rootcausefailureanalysis/analyses'

      return (await ApiClient.axiosInstance.patch<ResponseType>(path, analysisData, {})).data
    },
    onSuccess: async (data: ResponseType) => {
      await Promise.all([
        queryClient.invalidateQueries({queryKey: ['graph-data']}),
        queryClient.invalidateQueries({queryKey: ['analysis-list']}),
        queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      ])
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
      queryClient.removeQueries({queryKey: ['analysis-summary']})
      queryClient.removeQueries({queryKey: ['analysis-list']})
      return data
    },
    onError: (error: AxiosError<HttpError>) => {
      if (error?.response?.status === 403) {
        spawnErrorToast(t('errors.cannotAssignOwnerRole'), {closeOnClick: true})
      }
    }
  })
}
